module.exports = __webpack_public_path__ + "static/media/JP_RC_EYELASHES03.46e169ab.jpg";